/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// eslint-disable-next-line no-console
console.log('Custom Shopify Theme by EcomGraduates LLC | Learn more at https://www.ecomgraduates.com')

// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new bootstrap.Popover(el))

// Shopify's callenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
    ?.classList.add('btn-primary')

// Shopify's errors message - Add BS classes
const errors = document.querySelectorAll('.errors')
errors.forEach(error => {
    error.classList.add('alert', 'alert-danger')
    error.querySelector('ul').classList.add('mb-0')
})

// Detect scroll
window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
        document.documentElement.classList.add('scrolled')
    } else {
        document.documentElement.classList.remove('scrolled')
    }
})

// Detect when element is within the scroll view
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
const initEnterViewAnimations = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // console.log(entry)
                entry.target.classList.add('entered')
                entry.target.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
                    el.classList.remove('opacity-0')
                    el.classList.add(el.dataset.animateClass)
                })
            }
        })
    }, { threshold: 0, rootMargin: '0px 0px -200px 0px' })

    document.querySelectorAll('.enter-view').forEach((el) => {
        observer.observe(el)
    })
}
initEnterViewAnimations()

// Fix EnterView animations within Shopify Theme Editor
document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.enter-view').forEach((enterViewEl) => {
        enterViewEl.classList.add('entered')
        document.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
            el.classList.remove('opacity-0')
        })
    })
})

// Save ingredients data from Firebase in cache
const savedIngredientsData = () => {
    fetch("https://us-central1-dime-app-8394d.cloudfunctions.net/api/ingredients")
        .then((response) => response.json())
        .then((data) => {
            localStorage.setItem("ingredientsData", JSON.stringify(data));
        })
        .catch((error) => console.error("Error fetching new data:", error));
};
savedIngredientsData();

const onHashChange = () => {
    if(window.location.href.includes("custom-bundle")) {
        localStorage.removeItem("custom_bundle_v3")
    }
}
onHashChange()

